import { HYDRATE } from 'next-redux-wrapper';

import { RootState } from '@zoopla/redux-types';
import {
    UPDATE_CURRENT_SORT_ORDER,
    INITIALISE,
    RESET_SORT_ORDER,
    RawSortOrderData,
    ListingsSortOrderState,
    InitialiseSortOrderAction,
    ListingsSortActionTypes
} from '@zoopla/redux-types';

const optionsText: { [key: string]: string } = {
    recommended: 'Recommended',
    mostRecent: 'Most recent',
    highestPrice: 'Highest price',
    lowestPrice: 'Lowest price',
    mostReduced: 'Most reduced'
};

// helpers
const convertRawSortOrderData = (sortOrderData: RawSortOrderData) => {
    const { options: rawOptions, currentSortOrder } = sortOrderData;

    const options = rawOptions.map((option) => {
        const { i18NLabelKey, value } = option;
        return {
            label: optionsText[i18NLabelKey],
            value
        };
    });

    const filteredOptions = options.filter((option) => {
        return option.value !== 'most_popular';
    });

    return {
        options: filteredOptions,
        currentSortOrder
    };
};

// Actions
export const initialiseSortOrder = (
    sortOrderData: RawSortOrderData
): InitialiseSortOrderAction => ({
    type: INITIALISE,
    sortOrderData
});

export const updateCurrentSortOrder = (currentSortOrder: string) => ({
    type: UPDATE_CURRENT_SORT_ORDER,
    currentSortOrder
});

export const resetSortOrder = () => ({
    type: RESET_SORT_ORDER
});

// Reducer

export const listingsSortOrder = (
    state: ListingsSortOrderState = {
        currentSortOrder: undefined,
        options: []
    },
    action: ListingsSortActionTypes
): ListingsSortOrderState => {
    switch (action.type) {
        case HYDRATE: {
            return {
                ...state,
                ...action.payload.listingsSortOrder
            };
        }
        case INITIALISE: {
            const { sortOrderData } = action;

            const { options, currentSortOrder } =
                convertRawSortOrderData(sortOrderData);

            return {
                ...state,
                options,
                currentSortOrder
            };
        }
        case UPDATE_CURRENT_SORT_ORDER: {
            const { currentSortOrder } = action;

            return {
                ...state,
                currentSortOrder
            };
        }
        case RESET_SORT_ORDER: {
            return {
                ...state,
                currentSortOrder: 'newest_listings'
            };
        }
        default:
            return {
                ...state
            };
    }
};

// Selectors
const selectListingsSort = (state: RootState): ListingsSortOrderState =>
    state.listingsSortOrder;

export const selectSortOrderOptions = (state: RootState) =>
    selectListingsSort(state).options;
export const selectCurrentSortOrder = (state: RootState) =>
    selectListingsSort(state).currentSortOrder;

export default listingsSortOrder;
